module.exports = __webpack_public_path__ + "img/1.bd62ac68.jpg";